import { useState } from 'react'
import useResizeEventListener from 'src/hooks/useResizeEventListener.hook'

const useDynamicWidth = () => {
  const [width, setWidth] = useState(window.innerWidth)
  const setDynamicWidthHandler = () => setWidth(window.innerWidth)

  useResizeEventListener(setDynamicWidthHandler)
  return { deviceWidth: width }
}

export default useDynamicWidth
